export const IMAGE_BASE = `${window.addiesaas.url}/images/supercharged/would-you-like-to`

export const BLOCKS = [
  { route: 'racewaybooking.race', title: 'Book a race', message: 'Would you like to reserve a race?', image: `${IMAGE_BASE}/racewaybooking.race.png` },
  { route: 'racewaybooking.ninja', title: 'Book ninja wipeout', message: 'Would you like to reserve ninja wipeout?', image: `${IMAGE_BASE}/racewaybooking.ninja.png` },
  { route: 'supercharged.axe-throwing', title: 'Book axe throwing', message: 'Would you like to reserve axe throwing?', image: `${IMAGE_BASE}/supercharged.axe-throwing.png` },
  { route: 'racewaybooking.gift-card', title: 'Buy a gift card', message: 'Would you like to purchase a gift card?', image: `${IMAGE_BASE}/racewaybooking.gift-card.png` },
  { route: 'supercharged.buy-play-card', title: 'Buy a {{PLAYCARD}}', message: 'Would you like to purchase a {{PLAYCARD}}?', image: `${IMAGE_BASE}/supercharged.buy-play-card.png` },
  { route: 'supercharged.reload-play-card', title: 'Reload a {{PLAYCARD}}', message: 'Would you like to reload a {{PLAYCARD}}?', image: `${IMAGE_BASE}/supercharged.reload-play-card.png` },
]

export default {
  IMAGE_BASE,
  BLOCKS
}
